"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonTypeForLicense = exports.hasIndividualLicense = exports.isTrialLicenses = exports.iconsForLicenseType = exports.getLicenseTypeByBundleName = exports.stringsForLicenseType = exports.LicenseBuyStatus = exports.LicenseButtonType = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const EMPTY_STRINGS = { name: '', description: '' };
var LicenseButtonType;
(function (LicenseButtonType) {
    LicenseButtonType[LicenseButtonType["None"] = 0] = "None";
    LicenseButtonType[LicenseButtonType["Reactivate"] = 1] = "Reactivate";
    LicenseButtonType[LicenseButtonType["Details"] = 2] = "Details";
})(LicenseButtonType || (exports.LicenseButtonType = LicenseButtonType = {}));
var LicenseBuyStatus;
(function (LicenseBuyStatus) {
    LicenseBuyStatus[LicenseBuyStatus["ACTIVE"] = 0] = "ACTIVE";
    LicenseBuyStatus[LicenseBuyStatus["NOT_RENEWAL"] = 1] = "NOT_RENEWAL";
    LicenseBuyStatus[LicenseBuyStatus["REFUNDED"] = 2] = "REFUNDED";
    LicenseBuyStatus[LicenseBuyStatus["REVOKED"] = 4] = "REVOKED";
    LicenseBuyStatus[LicenseBuyStatus["BILLING_RETRY"] = 5] = "BILLING_RETRY";
    LicenseBuyStatus[LicenseBuyStatus["CHURNED"] = 6] = "CHURNED";
    LicenseBuyStatus[LicenseBuyStatus["DOWNGRADED"] = 7] = "DOWNGRADED";
})(LicenseBuyStatus || (exports.LicenseBuyStatus = LicenseBuyStatus = {}));
// TODO: add info about other licenses visible in user profile
const stringsForLicenseType = (type) => {
    switch (type) {
        case bridge_schema_1.LicenseType.Individual:
            return i18n_1.Strings.userLicenses.individual;
        case bridge_schema_1.LicenseType.StudentPlus:
            return i18n_1.Strings.userLicenses.studentPlus;
        case bridge_schema_1.LicenseType.Edu:
            return i18n_1.Strings.userLicenses.educator;
        case bridge_schema_1.LicenseType.Institutional:
            return i18n_1.Strings.userLicenses.institutional;
        case bridge_schema_1.LicenseType.Pro:
        case bridge_schema_1.LicenseType.TrialManual:
        case bridge_schema_1.LicenseType.TrialRegistration:
        case bridge_schema_1.LicenseType.TrialQuizReward:
        case bridge_schema_1.LicenseType.TrialDrChrono:
        case bridge_schema_1.LicenseType.TrialSpecialType1:
        case bridge_schema_1.LicenseType.TrialSpecialType2:
        case bridge_schema_1.LicenseType.TrialSpecialType3:
            return i18n_1.Strings.userLicenses.pro;
        case bridge_schema_1.LicenseType.School:
            return i18n_1.Strings.userLicenses.school;
        default: {
            return EMPTY_STRINGS;
        }
    }
};
exports.stringsForLicenseType = stringsForLicenseType;
const getLicenseTypeByBundleName = (bundleName) => {
    switch (bundleName) {
        case 'B2B.StuPlusLicense':
            return bridge_schema_1.LicenseType.StudentPlus;
        case 'B2B.EduLicense':
            return bridge_schema_1.LicenseType.Edu;
        case 'B2B.ProLicense':
            return bridge_schema_1.LicenseType.Pro;
        default:
            return bridge_schema_1.LicenseType.StudentPlus;
    }
};
exports.getLicenseTypeByBundleName = getLicenseTypeByBundleName;
const USER_LICENSE_ICONS = {
    [bridge_schema_1.LicenseType.Individual]: 'individual-license',
    [bridge_schema_1.LicenseType.StudentPlus]: 'student-license',
    [bridge_schema_1.LicenseType.Edu]: 'educator-license',
    [bridge_schema_1.LicenseType.Institutional]: 'institution-license',
    [bridge_schema_1.LicenseType.Pro]: 'professional-license',
    [bridge_schema_1.LicenseType.School]: 'school-license',
    [bridge_schema_1.LicenseType.TrialManual]: 'professional-license',
    [bridge_schema_1.LicenseType.TrialRegistration]: 'professional-license',
    [bridge_schema_1.LicenseType.TrialQuizReward]: 'professional-license',
    [bridge_schema_1.LicenseType.TrialDrChrono]: 'professional-license',
    [bridge_schema_1.LicenseType.TrialSpecialType1]: 'professional-license',
    [bridge_schema_1.LicenseType.TrialSpecialType2]: 'professional-license',
    [bridge_schema_1.LicenseType.TrialSpecialType3]: 'professional-license',
};
const iconsForLicenseType = (type) => USER_LICENSE_ICONS[type];
exports.iconsForLicenseType = iconsForLicenseType;
/* @todo add check for trial */
function isTrialLicenses(licenses) {
    return licenses === null || licenses === void 0 ? void 0 : licenses.some(license => license.type === bridge_schema_1.LicenseType.TrialRegistration ||
        license.type === bridge_schema_1.LicenseType.TrialManual ||
        license.type === bridge_schema_1.LicenseType.TrialSpecialType1);
}
exports.isTrialLicenses = isTrialLicenses;
function hasIndividualLicense(licenses) {
    return licenses === null || licenses === void 0 ? void 0 : licenses.some(license => license.type === bridge_schema_1.LicenseType.Individual);
}
exports.hasIndividualLicense = hasIndividualLicense;
function buttonTypeForLicense(license) {
    const isExpired = license.expireAt.getTime() < Date.now();
    if (license.status === LicenseBuyStatus.NOT_RENEWAL || isExpired) {
        return LicenseButtonType.Reactivate;
    }
    if (!license.isActive) {
        return LicenseButtonType.Reactivate;
    }
    if (!license.subscriptionManagementURL) {
        return LicenseButtonType.None;
    }
    switch (license.type) {
        case bridge_schema_1.LicenseType.Individual:
        case bridge_schema_1.LicenseType.StudentPlus:
        case bridge_schema_1.LicenseType.Edu:
        case bridge_schema_1.LicenseType.Pro: {
            return LicenseButtonType.Details;
        }
        default:
            return LicenseButtonType.None;
    }
}
exports.buttonTypeForLicense = buttonTypeForLicense;
